import RestUtility from '../../../restUtility';
import {
  dsoFavouriteEndPoint,
  dsoProductsEndPoint,
} from '../../../restUtility/restEndpoints';
import { notifyError } from 'config/setupBugsnag';
import { DsoProductSearchResponse } from 'types/dso/DsoProduct.types';

export class DsoProductService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
  }

  async getProductSearch(): Promise<DsoProductSearchResponse> {
    try {
      return await this.restUtility.get<DsoProductSearchResponse>(
        `${dsoProductsEndPoint}/search`
      );
    } catch (error) {
      notifyError('ApiError:: getProductSearch', error);
      throw error;
    }
  }

  async getDsoFavouriteProductIds() {
    try {
      const response = await this.restUtility.get<number[]>(
        `${dsoFavouriteEndPoint}`
      );
      return response.map(id => id.toString());
    } catch (error) {
      notifyError('ApiError:: getDsoFavouriteProductIds', error);
      throw error;
    }
  }

  async dsoToggleFavouriteProduct(variantId: number) {
    try {
      const response = await this.restUtility.post<{
        isFavourite: boolean;
      }>(`${dsoFavouriteEndPoint}/toggle`, {
        variant_id: variantId,
      });
      return response;
    } catch (error) {
      notifyError('ApiError:: dsoToggleFavouriteProduct', error);
      throw error;
    }
  }
}
